import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../common/store/types';
import { ListItem } from '../typeahead/types';
import { groupActions } from './group.actions';

export interface IGroupState extends IState<ListItem[]> {
  getListItem: GenericState<ListItem[]>;
}

export const groupInitialState: IGroupState = {
  getListItem: new GenericState<ListItem[]>(),
};

const groupReducers = [
  ...onApiCall<ListItem[]>(groupActions.getListItem, 'getListItem'),
];

export const groupReducer = createReducer(
  groupInitialState,
  ...groupReducers,
) as ActionReducer<IGroupState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return groupReducer(state, action);
}
